/*
* Created on May 27, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

export const getTimeWithTimezone = (utcDatetime, useTime = true) => {
    let utc = utcDatetime;
    if (utc) {
        if (utc[utc.length - 1] !== 'Z') {
            utc += 'Z';
        }
        const localDate = new Date(utc);
        const year = localDate.getFullYear();
        let month = localDate.getMonth() + 1;
        month = month < 10 ? `0${month}` : month;
        let date = localDate.getDate();
        date = date < 10 ? `0${date}` : date;
        let hour = localDate.getHours();
        hour = hour < 10 ? `0${hour}` : hour;
        let minute = localDate.getMinutes();
        minute = minute < 10 ? `0${minute}` : minute;
        let second = localDate.getSeconds();
        second = second < 10 ? `0${second}` : second;
        if (!useTime) return `${year}-${month}-${date}`
        return `${year}-${month}-${date} ${hour}:${minute}:${second}`
    }
    return '-';
}

export const useTimezone = (utcDatetime, useTime = true) => {
    return getTimeWithTimezone(utcDatetime, useTime);
};

export const formatDateTime = (isoString) => {
    if (!isoString) {
        return '-';
    }
    const date = new Date(isoString);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    };

    return new Intl.DateTimeFormat('en-US', options)
        .format(date)
        .replace(/(\d+)\/(\d+)\/(\d+),\s(.*)/, '$3/$1/$2 $4');
}